import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import { ProductPayload } from '~types/index'

export const goToPromoTag = (
  router: AppRouterInstance,
  tag: ProductPayload['tag']
) =>
  router.push(
    `/tagFilter?name=${tag?.name}&filterId=${tag?.filterId}&description=${tag?.description}`
  )
